import { useReactToPrint } from 'react-to-print';
import { ReactComponent as IconPrinter } from "assets/images/icons/printer.svg";
import { toast } from "react-toastify";


const Print = (props) => {
    const section = props.component;

    const handlePrint = useReactToPrint({
        content: () => section.current,
    });
    
    const printComponent = () => {
        if (section){
            handlePrint();
        }
        else{
            toast.error("Section to print is not specified");
        }
    }

    return ( 
        <div onClick={printComponent} className="h-full btn px-3 text-sm border border-gray-300 cursor-pointer hover:bg-[#F4F4F4]">
            <IconPrinter className='h-5'/>
            <span>Print</span>
        </div>
    )
}


export default Print;